import { observable } from '@legendapp/state';
import { getDecimalScaleForCurrency } from '../utils';

type ConfigurationState = {
  coeficient: number;
  currency: string;
  currencyType: string;
  currencyExchangeRate: number;
  minBet: number;
  maxBet: number;
  maxWin: number;
  predefinedBets: number[];
  decimalScale: number;
  betStepAmount: number;
};

export const configurationState$ = observable<ConfigurationState>({
  coeficient: 1, // Default to 1 to prevent division by zero
  currency: '',
  currencyType: '',
  currencyExchangeRate: 1,
  minBet: 0,
  maxBet: 0,
  maxWin: 0,
  predefinedBets: [],
  decimalScale: (): number => {
    const currency = configurationState$.currency.get();

    if (!currency) {
      return 2;
    }

    return getDecimalScaleForCurrency(currency);
  },
  betStepAmount: 0,
});
